/**
 * Tracks whether a newer frontend build has been deployed since this tab
 * loaded. Deliberately a plain module singleton (not a Jotai atom) so the
 * router subscription in main.tsx — which lives outside React — can read it
 * without a provider.
 *
 * The flag is one-way: once a newer deploy is seen it stays pending until the
 * tab reloads onto that build. See useVersionCheck (writer) and the
 * onBeforeNavigate handler in main.tsx (reader: it upgrades the next
 * cross-page navigation into a full document load so the user silently lands
 * on the fresh build).
 */
let pending = false

export function markUpdatePending(): void {
  pending = true
}

export function isUpdatePending(): boolean {
  return pending
}
